/**
 * @file
 */
const queryString = require("qs");

const CONFIG = {
    phpConfig: {
        // adapter: cache.adapter,
        timeout: '',
        baseURL: 'http://jingfu.yft96299.com/',
        headers: {
            post: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            common: {
                "X-Requested-With": "XMLHttpRequest"
            }
        },
        responseType: "json",
        transformRequest: [
            function (data) {
                if (typeof data === "string") {
                    return data;
                }
                return queryString.stringify(data);
            }
        ]
    }
};

export default CONFIG;